import React from 'react';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../constants';

export default ({ customPlanPricing }) => {
  const {
    id,
    att_plan,
    att_plan_name,
    simo_plan,
    simo_plan_name,
    quick_plan,
    quick_plan_name,
    user_profile,
    activation_fee,
    price,
    original_price,
    is_visible,
    is_effective,
    effective_start_at,
    effective_end_at,
  } = customPlanPricing;
  return (
    <div className="mar-t">
      <table className="table">
        <tbody>
          <tr>
            <td>
              <b>ID</b>
            </td>
            <td>{id}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>AT&T Plan</b>
            </td>
            <td>{att_plan}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>AT&T plan name</b>
            </td>
            <td>{att_plan_name}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Simo Plan</b>
            </td>
            <td>{simo_plan}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Simo plan name</b>
            </td>
            <td>{simo_plan_name}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Quick Plan</b>
            </td>
            <td>{quick_plan}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Quick plan name</b>
            </td>
            <td>{quick_plan_name}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>User Profile ID</b>
            </td>
            <td>{user_profile}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Activation Fee</b>
            </td>
            <td>{activation_fee}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Price</b>
            </td>
            <td>{price}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Original Price</b>
            </td>
            <td>{original_price}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Visible</b>
            </td>
            <td>{String(is_visible)}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Effective</b>
            </td>
            <td>{String(is_effective)}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Effective Start At</b>
            </td>
            <td>
              {effective_start_at
                ? moment(effective_start_at).format(DATE_TIME_FORMAT)
                : effective_start_at}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Effective End At</b>
            </td>
            <td>
              {effective_end_at
                ? moment(effective_end_at).format(DATE_TIME_FORMAT)
                : effective_end_at}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
